// extracted by mini-css-extract-plugin
export default {"github":"ProfileName_github__aT9eQ","githubLogo":"ProfileName_githubLogo__3fqt2"};